module.exports = __webpack_public_path__ + "static/mergesort-hero-0ddb03e5e88ba5bc33dafb08de06f621.png";